import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import Config from '@/config/default/config'
import { adminPages } from '@/router/pages/admin'
import { beforeEachRoute } from '@/router/routerLogic'
import { authPages } from '@/router/pages/auth'
import { commonPages } from '@/router/pages/common'
import { afterEachRoute } from '@/router/after'
import { devPages } from '@/router/pages/dev'
import { profilePages } from '@/router/pages/profile'
import { importPages } from '@/router/pages/import'
import { journalsPages } from '@/router/pages/journals'
import { requestsPages } from '@/router/pages/requests'
import { managementPages } from '@/router/pages/management'
import { publicationsPages } from '@/router/pages/publications'
import { cttPages } from '@/router/pages/ctt'

Vue.use(VueRouter)

export const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: Config.routing.homePage.path,
    children: [
      ...profilePages,
      ...cttPages,
      ...requestsPages,
      ...importPages,
      ...journalsPages,
      ...managementPages,
      ...publicationsPages,
      ...adminPages,
      ...authPages,
      ...commonPages,
      ...devPages
    ]
  }
]

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(beforeEachRoute)
router.afterEach(afterEachRoute)
